import React from 'react';
import Slider from 'react-slick';
import PortfolioSlider from './TestimonialsSlider';
import './Testimonials.css'

const Testimonials = () => {
    const testimonialsInfo = [
        {
            id: 1,
            title: 'Landing page design',
            // img: <FaCode className='social-icon text-warning' />,
            des: ['html', 'css', 'bootstrap', 'javascript']
        },
        {
            id: 2,
            title: 'Web Design & Development',
            // img: <FaReact className='social-icon text-warning' />,
            des: ['html', 'css', 'bootstrap/tailwind css', 'javascript', 'react']
        },
        {
            id: 3,
            title: 'Dashboard or Admin panel Design',
            // img: <FaJsSquare className='social-icon text-warning' />,
            des: ['html', 'css', 'bootstrap/tailwind css', 'javascript', 'react']
        },
        {
            id: 4,
            title: 'Implement Firebase in React App',
            // img: <FaSign className='social-icon text-warning' />,
            des: ['react js', 'firebase']
        },
        {
            id: 5,
            title: 'Mongodb Database Connection',
            // img: <FaDatabase className='social-icon text-warning' />,
            des: ['react js', 'mongodb']
        },
        {
            id: 6,
            title: 'Upload Website in Live Server',
            // img: <FaUpload className='social-icon text-warning' />,
            des: ['firebase', 'Shared Hosting']
        },
    ]


    return (
        <div className='testimonials-section py-5'>
            <div className=''>
                <div className='text-center mb-5'>
                    <p><span className='text-capitalize heading-two text-center'>testimonials</span></p>
                    <h2 className='heading-three'>Happy Clients Says</h2>
                </div>
                <PortfolioSlider></PortfolioSlider>
            </div>
        </div>
    );
};

export default Testimonials;